import React from "react";
import surgeonImage from "../../assets/images/main-banner-new.png";
import "./Innovation.css";

const InnovationSection = () => {
  return (
    <section className="innovation-section">
      <div className="innovation-wrapper">

        {/* Full-width header */}
        <div className="innovation-header">
          <h2 className="innovation-title">Our Innovation Story</h2>
          <blockquote className="innovation-quote">
            We didn’t set out to copy. <br />
            We set out to solve.
          </blockquote>
        </div>

        {/* Two-column top half */}
        <div className="innovation-top">
          <div className="innovation-image">
            <img src={surgeonImage} alt="Surgeon" />
            <div className="badge">SABIOTE <span>Healthcare</span></div>
          </div>

          <div className="innovation-content">
            <div className="innovation-card">
              <p>
                The Indian market for pulse lavage systems was entirely dependent on imports.
                Supply disruptions were common, prices were volatile, and accessibility remained
                a serious challenge — especially under government-regulated health schemes like
                <strong> Ayushman Bharat</strong> and <strong> NPPA</strong> price ceilings.
              </p>

              <p>
                With a clear focus on <strong>indigenous innovation</strong>, our R&D team at
                <strong> Sabiote Healthcare</strong> took complete ownership of the product
                development — from concept to validation. Every element of the PulsOjet® system —
                from the <em>safety lock mechanism</em>, <em>DC motor housing</em>,
                <em> Manifold</em>, to the <em>battery pack integration</em> and
                <em> fluid control design</em> — was engineered and refined in-house.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom half content - full width under image */}
        <div className="innovation-bottom">
          <div className="innovation-card">
            <p>
              We collaborated with <strong>Future Factory LLP</strong>, one of India’s top
              industrial design consultancies, to accelerate specific design and ergonomic phases.
              But the core architecture, performance tuning, and clinical readiness were driven
              entirely by our own engineers and product teams.
            </p>

            <p>
              This was not a quick project. It took over <strong>two years</strong> of focused R&D,
              multiple rounds of prototyping, clinical feedback, lab testing for pressure and suction
              performance, and repeated validations — to bring to life a pulse lavage system that
              meets the demands of real-world surgery and earns the trust of Indian surgeons.
            </p>
          </div>

          <div className="innovation-footer">
            <a
              href="/Project-Sterile-ID-Presentation-1.pdf"
              download
              className="download-btn"
            > Learn More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InnovationSection;
